import * as React from 'react';
import { CLUB_EVENT_EDIT_MODE } from '../../../../../../consts/event';

interface Props {
  editMode: string;
  onEditModeClick: (editMode: string) => void;
}

export function SchoolEventClubEventRadioButtons(props: Props) {
  const { editMode, onEditModeClick } = props;
  const isEditModeSingle = editMode === CLUB_EVENT_EDIT_MODE.SINGLE;
  const isEditModeGroup = editMode === CLUB_EVENT_EDIT_MODE.GROUP;

  return (
    <div className="bSchoolTeamManager__editScopeCard">
      <div className="bSchoolTeamManager__editScopeTitle">Apply changes to</div>
      <div className="bSchoolTeamManager__editScopeText">
        Choose whether the updates should affect only this event or this event and all following events in the series.
      </div>

      <label className="bSchoolTeamManager__editScopeOption">
        <input
          className="bSchoolTeamManager__editScopeRadio"
          type="radio"
          name="eventEditMode"
          value={CLUB_EVENT_EDIT_MODE.SINGLE}
          checked={isEditModeSingle}
          onChange={() => {
            onEditModeClick(CLUB_EVENT_EDIT_MODE.SINGLE);
          }}
        />
        <span className="bSchoolTeamManager__editScopeOptionBody">
          <span className="bSchoolTeamManager__editScopeOptionTitle">Only this event</span>
          <span className="bSchoolTeamManager__editScopeOptionText">Update just the current event.</span>
        </span>
      </label>

      <label className="bSchoolTeamManager__editScopeOption">
        <input
          className="bSchoolTeamManager__editScopeRadio"
          type="radio"
          name="eventEditMode"
          value={CLUB_EVENT_EDIT_MODE.GROUP}
          checked={isEditModeGroup}
          onChange={() => {
            onEditModeClick(CLUB_EVENT_EDIT_MODE.GROUP);
          }}
        />
        <span className="bSchoolTeamManager__editScopeOptionBody">
          <span className="bSchoolTeamManager__editScopeOptionTitle">This and following events</span>
          <span className="bSchoolTeamManager__editScopeOptionText">
            Apply the same changes to the remaining events in the series.
          </span>
        </span>
      </label>
    </div>
  );
}
